export const ClearIcon = require('./clear.svg')
